













































































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { CollectionFlag, Prefix, SortOrder } from '@/types'
import { orderBy } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import { SystemCode } from '@/api'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import { dateToPlainFormat } from '@/utils'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'

export interface InputItem {
  prefix: Prefix
  searchType: SystemCode
  id: number
  displayTitle: string
  collectionType: SystemCode
  handlingType: SystemCode
  lendTime: string
  lendType: SystemCode
  dueDate: string
  extendCount: number
  extendDueDate: {
    input: string
    errorMessage: string
  }
  hasReservation: boolean
  message: string
  canExtend: boolean
  collectionFlag: CollectionFlag
  revision: number
}

@Component({
  components: {
    IconBibliography,
    InputDatePicker,
    DataTable
  }
})
export default class LendExtensionTable extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: InputItem[]

  @Prop({
    type: Array
  })
  checkedCollectionIds!: string[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean
  })
  isAllSelect!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  dialog!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return [
      {
        width: 26,
        items: [
          {
            name: 'check',
            align: 'center'
          }
        ]
      },
      {
        width: 50,
        items: [
          {
            name: 'no',
            align: 'right'
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'canExtend',
            headerText: '延長',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '13',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'displayTitle',
            headerText: 'タイトル',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'collectionNo',
            headerText: '資料番号',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'collectionType',
            headerText: '資料区分',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'handlingType',
            headerText: '取扱区分',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'lendTime',
            headerText: '貸出日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'dueDate',
            headerText: '返却予定日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '9',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'extendCount',
            headerText: '延長回数',
            align: 'right',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '14',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'extendDueDate',
            headerText: '延長後返却予定日',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '5',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'hasReservation',
            headerText: '予約',
            sortable: true,
            sortOrder: ''
          }
        ]
      },
      {
        width: '10',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'message',
            headerText: 'メッセージ',
            sortable: true,
            sortOrder: ''
          }
        ]
      }
    ]
  }

  get sortedItems(): InputItem[] {
    if (this.sortName) {
      return orderBy<InputItem>(
        this.items,
        (item: InputItem) => {
          const propertyValue = item[this.sortName as keyof InputItem]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  @Watch('dialog')
  initializeSort(): void {
    if (this.dialog) return

    this.onSort({
      name: '',
      order: ''
    })
  }

  @Emit('select:all')
  onClickAllSelect(): void {}

  @Emit('select:collection-id')
  onChangeCheckedCollectionIds(collectionId: number): number {
    return collectionId
  }

  onInputExtendDueDate(date: string, collectionId: number) {
    this.$emit(
      'input:extend-due-date',
      dateToPlainFormat(date),
      this.items.findIndex(item => {
        return item.id === collectionId
      })
    )
  }

  isStringNumber(str: string): boolean {
    return !isNaN(Number(str))
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onClickRow(index: number) {
    this.onChangeCheckedCollectionIds(this.sortedItems[index].id)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
